/* tslint:disable */
import { ConfigurationModel } from './configuration-model';
import { IOverrides, IConfigurationRegistry } from '../interfaces';
import { OVERRIDE_PROPERTY_PATTERN } from '../constants';
import { overrideIdentifierFromKey, toValuesTree } from '../utils/configuration';
import { getConfigurationKeys, getDefaultValues } from '../utils';

export class DefaultConfigurationModel extends ConfigurationModel {

    constructor() {
        const contents = getDefaultValues();
        const keys = getConfigurationKeys();
        const overrides: IOverrides[] = [];
        for (const key of Object.keys(contents)) {
            if (OVERRIDE_PROPERTY_PATTERN.test(key)) {
                overrides.push({
                    identifiers: [overrideIdentifierFromKey(key).trim()],
                    contents: toValuesTree(contents[key], message => console.error(`Conflict in default settings file: ${message}`))
                });
            }
        }
        super(contents, keys, overrides);
    }
}

